import React, { useState } from "react";
import { Colors } from "./styles/Colors";

export default function Checkbox() {
  return (
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 9l6 6 6-6"
        stroke={ Colors.grey }
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}